import { getPrice, getIdByGraphQlId } from 'libs/shopify'

const normalizeProducts = (products, type) => {
  if (!products || !products.length) {
    // eslint-disable-next-line no-console
    console.warn('normalizeProducts was called without products')

    return []
  }

  switch (type) {
    case 'shopify-graphql':
      return products.map((product) => normalizeProductGraphql(product))

    case 'shopify-graphql-recommendations':
      return products.map((product) => normalizeProductGraphql(product))
  }
}

const resultCustomFields = (customFields) => {
  return customFields.map((item) => ({
    key: item?.namespace + '-' + item?.key,
    value: item?.value
  }))
}

const getVariantPrice = (amount) => {
  if (amount === undefined) {
    return undefined
  }

  return getPrice(amount)
}

const getImage = (item) => {
  if (!item?.id) {
    return null
  }

  return {
    id: getIdByGraphQlId(item.id),
    src: item.src,
    alt: item.altText,
    width: item.width,
    height: item.height
  }
}

const getImages = (items) => {
  if (!items || items.length === 0) return []

  return items.map((item) => getImage(item))
}

const getVariant = (variant) => {
  return {
    available: variant.availableForSale,
    barcode: variant.barcode,
    id: getIdByGraphQlId(variant.id),
    sku: variant.sku,
    title: variant.title,
    price: getVariantPrice(variant.price?.amount),
    compare_at_price: getVariantPrice(variant.compareAtPrice?.amount),
    image: getImage(variant.image),
    inventory_quantity: variant.quantityAvailable,
    options: variant.selectedOptions.map(x => x.value),
    weight: variant.weight,
    weight_unit: variant.weightUnit,
    inventory_policy: (!variant.quantityAvailable && variant.availableForSale) ? 'continue' : '',
    inventory_management: variant.quantityAvailable != null ? 'shopify' : ''
  }
}

const getVariants = (variants) => {
  if (!variants) {
    return []
  }

  return variants.map((variant) => getVariant(variant))
}

const normalizeProductGraphql = (product) => {
  return {
    id: getIdByGraphQlId(product.id),
    available: product.availableForSale,
    vendor: product.vendor,
    title: product.title,
    handle: product.handle,
    url: product.onlineStoreUrl,
    options_with_values: product.options,
    featuredImage: getImage(product.featuredImage),
    images: getImages(product.images.nodes),
    price: getPrice(product.priceRange.minVariantPrice.amount),
    compare_at_price: getPrice(product.compareAtPriceRange.minVariantPrice.amount),
    tags: product.tags,
    initialVariant: getVariant(product.variants.nodes[0]),
    variants: getVariants(product.variants.nodes),
    metafields: resultCustomFields(product.metafields)
  }
}

export {
  normalizeProducts
}
